
import { CloudServerOutlined } from "@ant-design/icons";
import AwsEC2Logo from "../assets/aws-ec2.svg";
import AwsRDSLogo from "../assets/aws-rds.svg";
import { Tooltip } from "antd";

interface CloudServiceIconProps {
    service: string
}

const CloudServiceIcon = ({
    service
}: CloudServiceIconProps) => {
    return service === "ec2" ? <Tooltip title={service}><img src={AwsEC2Logo} style={{ width: "15px" }} alt="ec2" /></Tooltip> :
        service === "rds" ? <Tooltip title={service}><img src={AwsRDSLogo} style={{ width: "15px" }} alt="rds" /></Tooltip> :
            <CloudServerOutlined />;

}

export default CloudServiceIcon;